import { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, ChevronDown, ChevronUp, Truck } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ReportCard = ({ r }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl" data-testid={`client-report-${r.id}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex flex-wrap items-center gap-x-6 gap-y-1 p-4 text-left">
        <span className="text-white font-semibold">{r.date}</span>
        <span className="text-slate-300 text-sm">{r.driver_name}</span>
        {r.vehicle_label && <span className="text-slate-400 text-xs flex items-center gap-1"><Truck size={12} />{r.vehicle_label}</span>}
        <span className="text-slate-400 text-xs">{r.start_time || '--'} → {r.end_time || '--'}</span>
        <span className="text-slate-400 text-xs">{Math.round(r.total_km || 0)} km · {r.stops.length} arrêt{r.stops.length > 1 ? 's' : ''}</span>
        <span className="ml-auto text-xs text-slate-500">{r.report_number}</span>
        {open ? <ChevronUp size={16} className="text-slate-400" /> : <ChevronDown size={16} className="text-slate-400" />}
      </button>
      {open && (
        <div className="border-t border-slate-800 p-4 space-y-2">
          {r.stops.map((s, i) => (
            <div key={i} className="flex gap-3 text-sm">
              <span className="text-amber-500 font-semibold w-6">{i + 1}</span>
              <div>
                <p className="text-white">{s.client_name || s.address}</p>
                {s.client_name && <p className="text-xs text-slate-400">{s.address}</p>}
                <p className="text-xs text-slate-500">{s.arrival_time || '--'} → {s.departure_time || '--'}{s.notes ? ` · ${s.notes}` : ''}</p>
              </div>
            </div>
          ))}
          {!r.stops.length && <p className="text-xs text-slate-500">Aucun arrêt</p>}
        </div>
      )}
    </div>
  );
};

export const ClientReportsTab = () => {
  const [reports, setReports] = useState(null);
  const [days, setDays] = useState(30);

  useEffect(() => {
    const token = localStorage.getItem('client_portal_token');
    axios.get(`${API_URL}/api/saas/portal/client/reports?days=${days}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setReports(r.data.reports)).catch(() => setReports([]));
  }, [days]);

  return (
    <div data-testid="client-reports-tab">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-white flex items-center gap-2"><FileText size={20} /> Rapports journaliers</h2>
        <select value={days} onChange={e => setDays(Number(e.target.value))} data-testid="client-reports-days"
          className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-1.5 text-sm text-white">
          <option value={7}>7 derniers jours</option>
          <option value={30}>30 derniers jours</option>
          <option value={90}>90 derniers jours</option>
        </select>
      </div>
      {reports === null ? <p className="text-slate-500 text-sm">Chargement…</p> : (
        <div className="space-y-2">
          {reports.map(r => <ReportCard key={r.id} r={r} />)}
          {!reports.length && <p className="text-slate-500 text-sm py-8 text-center">Aucun rapport sur cette période</p>}
        </div>
      )}
    </div>
  );
};
